import { findCurrentBreakpoint } from './breakpoint';

const defaultStructure = {
  ga_action: undefined,
  ga_category: undefined,
  ga_label: undefined,
  ga_value: undefined,
};

function gtmEvent(name, data) {
  window.gtmEvents = window.gtmEvents || [];
  if (!window.dataLayer) {
    return window.gtmEvents.push({ name: name, data: data });
  }

  while (window.gtmEvents.length) {
    let event = window.gtmEvents.shift();
    pushEvent(event.name, event.data);
    console.log('GTM: Pushed cached event: ', event);
  }

  pushEvent(name, data);
}

function pushEvent(name, data) {
  window.gtag('event', name, {
    user_id: window.userId,
    user_properties: { user_type: 'creator' },
    device_user_agent: navigator?.userAgent,
    device_type: findCurrentBreakpoint().device,
    device_screen_size: window.screen.width + 'x' + window.screen.height,
    ...defaultStructure,
    ...data,
  });
}

export { gtmEvent };
